import { PropsWithChildren } from 'react';

import { Can } from '@casl/react';

import { Tooltip } from '@material-ui/core';

import { EPermissionActions, EPermissionSubjects } from './permissions';
import { usePermissions } from './provider';

interface BaseProps {
  subject: EPermissionSubjects;
  action: EPermissionActions;
  disabledOpacity?: boolean;
  tooltipText?: string;
}
interface Props extends PropsWithChildren<BaseProps> {}
export default function CheckAccess({ children, action, subject, disabledOpacity, tooltipText }: Props) {
  const permissions = usePermissions();
  return (
    <Can I={action} a={subject} ability={permissions} passThrough>
      {(allowed) =>
        allowed ? (
          children
        ) : (
          <Tooltip title={tooltipText || 'You don’t have enough rights to perform this action'} placement="bottom">
            <div className={`w-full cursor-not-allowed ${disabledOpacity ? '' : 'opacity-50'} `}>
              <div className="pointer-events-none w-full">{children}</div>
            </div>
          </Tooltip>
        )
      }
    </Can>
  );
}
